import { useRole } from '../../common/hooks/useRole';

import { AdminOfferOverviewPage } from './AdminOfferOverviewPage';
import { SupplierOfferOverviewPage } from './SupplierOfferOverviewPage';

export const OfferOverviewPage = () => {
    const role = useRole();

    if (role.isSupplier()) {
        return <SupplierOfferOverviewPage />;
    }

    return <AdminOfferOverviewPage />;
};
